<template>
  <el-card
    class="ds-detail"
    style="position: relative; z-index: 0; width: 100%"
  >
    <div slot="header" class="clearfix">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ item.PlatformName }}</el-tag>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="平台信息">
        <table
          border="1"
          bordercolor="#dedede"
          style="width: 100%; border-collapse: collapse"
        >
          <tr>
            <th width="12%">平台名称</th>
            <td width="37%">{{ item.PlatformName }}</td>
            <th width="12%">客户名称</th>
            <td width="37%">
              <div v-if="item.Contract && item.Contract.length">
                {{ item.Contract[0].Client.ClientName }}
              </div>
            </td>
          </tr>
          <tr>
            <th>业务类型</th>
            <td>
              <div v-if="item.BusinessType">
                {{ item.BusinessType.Name }}
              </div>
            </td>
            <th>平台级别</th>
            <td>
              <div v-if="item.PlatformLevel">
                {{ item.PlatformLevel.Name }}
              </div>
            </td>
          </tr>
          <tr>
            <th>平台授权码</th>
            <td>{{ item.PlatformCheckcode }}</td>

            <th>开发单位</th>
            <td>{{ item.DevelopeUnit }}</td>
          </tr>
          <tr>
            <th>通讯协议</th>
            <td>
              <div v-if="item.CommProtocol">
                {{ item.CommProtocol.Name }}
              </div>
            </td>
            <th></th>
            <td>
              <div></div>
            </td>
          </tr>
          <tr>
            <th>IP地址</th>
            <td>{{ item.IP }}</td>
            <th>端口号</th>
            <td>{{ item.Port }}</td>
          </tr>
          <tr>
            <th>质保/运维状态</th>
            <td>
              <div v-if="item.ProtectStatus">质保中</div>
              <div v-else>已过保</div>
            </td>
            <th>合同类型</th>
            <td>
              <div
                v-if="
                  item.Contract &&
                  item.Contract.length &&
                  item.Contract[0].ContractType
                "
              >
                {{ item.Contract[0].ContractType.Name }}
              </div>
            </td>
          </tr>
          <tr>
            <th>合同开始日期</th>
            <td>
              <div
                v-if="
                  item.Contract &&
                  item.Contract.length &&
                  item.Contract[0].ContractStartDay
                "
              >
                {{ item.Contract[0].ContractStartDay.substring(0, 10) }}
              </div>
            </td>
            <th>合同结束日期</th>
            <td>
              <div
                v-if="
                  item.Contract &&
                  item.Contract.length &&
                  item.Contract[0].ContractEndDay
                "
              >
                {{ item.Contract[0].ContractEndDay.substring(0, 10) }}
              </div>
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="服务器">
        <el-table
          :data="item.PlatformServers"
          v-loading="loading"
          size="medium"
        >
          <el-table-column
            type="index"
            :index="pager.size * (pager.page - 1) + 1"
            :width="
              Math.max(48, (pager.size * pager.page).toString().length * 12)
            "
          ></el-table-column>
          <el-table-column
            prop="ServerType.Name"
            label="服务器类型"
          ></el-table-column>
          <el-table-column prop="Manner.Name" label="方式"></el-table-column>
          <el-table-column
            prop="RemoteAccount"
            label="远程工具账号"
          ></el-table-column>
          <el-table-column
            prop="RemotePassword"
            label="远程工具密码"
          ></el-table-column>
          <el-table-column prop="IP" label="IP地址"></el-table-column>
          <el-table-column prop="Port" label="端口号"></el-table-column>
          <el-table-column
            prop="ServerUsername"
            label="服务器用户名"
          ></el-table-column>
          <el-table-column
            prop="ServerPassword"
            label="服务器密码"
          ></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="合同记录">
        <el-table
          :data="item.reverseContracts"
          v-loading="loading"
          size="medium"
        >
          <el-table-column
            type="index"
            :index="pager.size * (pager.page - 1) + 1"
            :width="
              Math.max(48, (pager.size * pager.page).toString().length * 12)
            "
          ></el-table-column>
          <el-table-column
            prop="ContractNumber"
            label="合同编号"
          ></el-table-column>
          <el-table-column prop="Name" label="合同名称"></el-table-column>
          <el-table-column
            prop="Client.ClientName"
            label="所属客户"
          ></el-table-column>
          <el-table-column label="合同签订日期">
            <template slot-scope="scope">
              <div v-if="scope.row.CheckDay">
                {{ scope.row.CheckDay.substring(0, 10) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="质保开始日期">
            <template slot-scope="scope">
              <div v-if="scope.row.ContractStartDay">
                {{ scope.row.ContractStartDay.substring(0, 10) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="质保结束日期">
            <template slot-scope="scope">
              <div v-if="scope.row.ContractEndDay">
                {{ scope.row.ContractEndDay.substring(0, 10) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="因子列表">
        <el-table :data="factorList">
          <el-table-column
            type="index"
            :index="factorPager.size * (factorPager.page - 1) + 1"
            :width="
              Math.max(
                48,
                (factorPager.size * factorPager.page).toString().length * 12
              )
            "
          ></el-table-column>
          <el-table-column
            prop="Factor.Name"
            label="因子名称"
          ></el-table-column>
          <el-table-column
            prop="Factor.CASNumber"
            label="化学符号学号"
          ></el-table-column>
          <el-table-column prop="Factor.Code" label="212编码">
            <template slot-scope="scope">
              <el-tag>
                {{ scope.row.Factor.Code }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="Factor.MeasureUnit.Name"
            label="计量单位"
          ></el-table-column>
          <el-table-column
            prop="Factor.DefaultDataType"
            label="缺省数据类型"
          ></el-table-column>
          <el-table-column prop="CusCode" label="自定义编码">
            <template slot-scope="scope">
              <div v-if="scope.row.CusCode">
                <div v-if="scope.row.CusCode !== scope.row.Factor.Code">
                  <el-tag type="danger">
                    {{ scope.row.CusCode }}
                  </el-tag>
                </div>
                <div v-else>
                  <el-tag>
                    {{ scope.row.CusCode }}
                  </el-tag>
                </div>
              </div>
              <div v-else>
                <el-tag>
                  {{ scope.row.Factor.Code }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="CusMeasureUnit.Name" label="自定义计量单位">
            <template slot-scope="scope">
              <div v-if="scope.row.CusMeasureUnit">
                <div
                  style="font-color: red"
                  v-if="
                    scope.row.CusMeasureUnitID !==
                    scope.row.Factor.MeasureUnitID
                  "
                >
                  <span style="color: red">
                    {{ scope.row.CusMeasureUnit.Name }}</span
                  >
                </div>
                <div v-else>
                  {{ scope.row.CusMeasureUnit.Name }}
                </div>
              </div>
              <div v-else>
                {{ scope.row.Factor.MeasureUnit.Name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="CusDefaultDataType" label="自定义缺省数据类型">
            <template slot-scope="scope">
              <div v-if="scope.row.CusDefaultDataType">
                <div
                  v-if="
                    scope.row.CusDefaultDataType !==
                    scope.row.Factor.DefaultDataType
                  "
                >
                  <span style="color: red">
                    {{ scope.row.CusDefaultDataType }}</span
                  >
                </div>
                <div v-else>
                  {{ scope.row.CusDefaultDataType }}
                </div>
              </div>
              <div v-else>
                {{ scope.row.Factor.DefaultDataType }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="60" label="更新">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click.stop="onChangeClick(scope.row)"
                title="更新"
                v-permission="'platform_factor-POST'"
              >
                <i class="fas fa-exchange-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="clearfix mar-top-10">
          <el-pagination
            class="pull-right"
            @current-change="onChangePage"
            layout="total, prev, pager, next"
            :total="factorPager.total"
            :current-page="factorPager.page"
            :page-size="factorPager.size"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="自定义因子信息"
      :visible.sync="factorvisible"
      append-to-body
      :close-on-click-modal="false"
      @close="factorvisible = false"
      width="30%"
    >
      <el-form
        ref="factorItemForm"
        label-width="120px"
        :model="factorItem"
        :rules="factorRules"
      >
        <el-form-item label="自定义编码" prop="CusCode">
          <el-input
            v-model.trim="factorItem.CusCode"
            placeholder="请输入自定义编码"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="计量单位" prop="CusMeasureUnitID">
          <select2
            labelName="Name"
            v-model="factorItem.CusMeasureUnitID"
            url="measureunit"
            placeholder="选择计量单位"
            no-data-text="没有计量单位"
            style="width: 100%"
            :urlParams="{
              where: {},
            }"
            q="Name:like"
            :qinwhere="true"
            :queryOne="false"
            :currentList="currentUnit"
          ></select2>
        </el-form-item>
        <el-form-item label="缺省数据类型" prop="CusDefaultDataType">
          <el-input
            v-model.trim="factorItem.CusDefaultDataType"
            placeholder="请输入缺省数据类型"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <div style="text-align: right">
          <el-button type="text" @click="syncFactor"
            >恢复因子配置信息</el-button
          >
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="factorvisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onChangeConfim" :disabled="changing">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      item: [],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,

      currentUnit: [],
      factorList: [],
      factorPager: {
        total: 0,
        page: 1,
        size: 15,
      },
      factorvisible: false,
      changing: false,
      factorItem: {},
      factorRules: {
        // CusCode: [{ required: true, message: "自定义编码不能为空", trigger: "blur" }],
        // CusMeasureUnitID: [
        //   { required: true, message: "计量单位不能为空", trigger: "blur" },
        // ],
        CusDefaultDataType: [
          // { required: true, message: "缺省数据类型不能为空", trigger: "blur" },
          {
            pattern: /N\d+\.\d*$/,
            message: "格式不正确,如：N4.2",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getItemData();
    this.getFactorList();
  },
  methods: {
    getItemData() {
      const params = {
        with: [
          "PlatformServers.ServerType",
          "PlatformServers.Manner",
          "PlatformServers.CommProtocol",
          "BusinessType",
          "PlatformLevel",
          "CommProtocol",
        ],
      };
      this.$axios
        .get(`platform/${this.$route.params.ID}`, { params })
        .then((response) => {
          this.item = response.data;
          this.item.reverseContracts = this.item.Contracts.reverse();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFactorList() {
      this.$axios
        .get("platform/factor", {
          params: {
            platform_id: this.$route.params.ID,
          },
          ...this.factorPager,
        })
        .then((response) => {
          this.factorList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 翻页
    onChangePage(page) {
      this.factorPager.page = page;
      this.getFactorList();
    },
    //点击更换按钮
    onChangeClick(row) {
      this.factorItem = _.clone(row);
      if (this.factorItem.CusMeasureUnitID === 0) {
        this.factorItem.CusMeasureUnitID = "";
      }
      this.currentUnit = [];
      if (this.factorItem.CusMeasureUnitID) {
        this.currentUnit = [
          {
            ID: this.factorItem.CusMeasureUnitID,
            Name: this.factorItem.CusMeasureUnit.Name,
          },
        ];
      }

      //如果未自定义，默认绑定因子管理中的配置信息
      if (this.factorItem.CusCode === "") {
        this.factorItem.CusCode = this.factorItem.Factor.Code;
      }
      if (this.factorItem.CusMeasureUnitID === "") {
        this.factorItem.CusMeasureUnitID = this.factorItem.Factor.MeasureUnitID;
        if (this.factorItem.CusMeasureUnitID === 0) {
          this.factorItem.CusMeasureUnitID = "";
        }
        this.currentUnit = [];
        if (this.factorItem.Factor.MeasureUnit) {
          this.currentUnit = [
            {
              ID: this.factorItem.CusMeasureUnitID,
              Name: this.factorItem.Factor.MeasureUnit.Name,
            },
          ];
        }
      }
      if (this.factorItem.CusDefaultDataType === "") {
        this.factorItem.CusDefaultDataType =
          this.factorItem.Factor.DefaultDataType;
      }

      this.factorvisible = true;
    },
    syncFactor() {
      this.factorItem.CusCode = this.factorItem.Factor.Code;
      this.factorItem.CusMeasureUnitID = this.factorItem.Factor.MeasureUnitID;
      if (this.factorItem.CusMeasureUnitID === 0) {
        this.factorItem.CusMeasureUnitID = "";
      }
      this.currentUnit = [];
      if (this.factorItem.Factor.MeasureUnit) {
        this.currentUnit = [
          {
            ID: this.factorItem.CusMeasureUnitID,
            Name: this.factorItem.Factor.MeasureUnit.Name,
          },
        ];
      }

      this.factorItem.CusDefaultDataType =
        this.factorItem.Factor.DefaultDataType;
    },
    onChangeConfim() {
      this.$refs.factorItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.changing = true;

        if (this.factorItem.CusMeasureUnitID === "") {
          this.factorItem.CusMeasureUnitID = 0;
        }

        this.$axios
          .request({
            url: "platform/factor",
            method: "post",
            data: this.factorItem,
          })
          .then(() => {
            this.changing = false;
            this.factorvisible = false;
            this.getFactorList();
            this.$message.success("更新成功");
          })
          .catch(({ response }) => {
            this.changing = false;
            this.$sys.alarmResponse(response);
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
  }
  table th {
    text-align: left;
    padding-left: 5px;
    color: #646566;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #cdcdcd;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ebf3f9;
    color: #646566;
  }
}
</style>
